import { OUTRIGHT_VALUE, REPAIR_FEE } from "MODULES/SalesOrders/constants";
import * as rules from "LIB/validation/rules";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { validateShippingFields } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection/validate";
import { validator } from "LIB/validate-this";

export function validate(values) {
  return validator(values, form => {
    if (values.flat_exchange) {
      form
        .validate(REPAIR_FEE)
        .satisfies(rules.required, rules.isLessThan(values.exchange_fee));
    }

    form.validate(EXCHANGE_FEE, OUTRIGHT_VALUE).satisfies(rules.required);

    validateShippingFields("return_to", values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/ConvertToExchange/validate.js